module.exports = __webpack_public_path__ + "img/Constance.fb9c1fdf.jpeg";